import { Link } from '@tanstack/react-router';

import { CachedImage } from '@common/ui/CachedImage';
import { Heading } from '@common/ui/typography/Heading';
import { Paragraph } from '@common/ui/typography/Paragraph';

import styles from './PremiumUpsell.module.scss';

export interface PremiumUpsellProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  title: string;
  subtitle: string;
  button: React.ReactNode;
  imgSrc?: string;
}

export const PremiumUpsell = ({
  title,
  subtitle,
  button,
  imgSrc = '/icons/3d-icons/filter.png',
  ...props
}: PremiumUpsellProps) => {
  return (
    <Link data-test-id="premium-upsell-link" to="/premium">
      <div
        {...props}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0',
        }}
      >
        <CachedImage
          testId="premium-upsell-image"
          className={styles.image}
          src={imgSrc}
          alt="result-image"
        />
        <Heading level={2} noPadding style={{ padding: '8px 0' }}>
          {title}
        </Heading>
        <Paragraph compact align="center" variant="secondary">
          {subtitle}
        </Paragraph>
        {button}
      </div>
    </Link>
  );
};
